module.exports = __webpack_public_path__ + "static/media/PDF_93.d5fec888.pdf";